// src/components/ReactFlow/CustomEdge.tsx

import { EdgeProps, getBezierPath } from "@xyflow/react";
import React from "react";

const CustomEdge: React.FC<EdgeProps> = ({
   id,
   sourceX,
   sourceY,
   targetX,
   targetY,
   sourcePosition,
   targetPosition,
   style = {},
   markerEnd,
   label,
}) => {
   const [edgePath] = getBezierPath({
      sourceX,
      sourceY,
      targetX,
      targetY,
      sourcePosition,
      targetPosition,
   });

   // Use predefined markerEnd or default to 'arrowclosed'
   const markerEndId = markerEnd || "arrowclosed";

   return (
      <>
         <path
            id={id}
            style={style}
            className="react-flow__edge-path"
            d={edgePath}
            markerEnd={markerEndId}
         />
         {label && (
            <text>
               <textPath
                  href={`#${id}`}
                  style={{ fontSize: 12 }}
                  startOffset="50%"
                  textAnchor="middle"
                  className="text-sm font-medium fill-current text-gray-700"
               >
                  {label}
               </textPath>
            </text>
         )}
      </>
   );
};

export default CustomEdge;
